import React from 'react';
import { SearchableSelect } from './shared/SearchableSelect';
import { API_BASE_URL } from '../config/api';
import mailIcon from '../assets/icons/mail.svg';

/**
 * SearchableCustomerSelect - Async searchable dropdown for customer selection
 *
 * @param {Function} apiCall - Authenticated API call function
 * @param {number} selectedCustomerId - Currently selected customer ID
 * @param {Function} onSelectCustomer - Callback when customer is selected (customerId)
 * @param {boolean} required - Whether the field is required
 * @param {number} storeId - Optional store filter
 */
export function SearchableCustomerSelect({ apiCall, selectedCustomerId, onSelectCustomer, required = true, storeId }) {
  const handleSearch = async (term) => {
    const params = new URLSearchParams({ search: term, limit: '20' });
    if (storeId) params.set('store_id', storeId);
    const res = await apiCall(`${API_BASE_URL}/customers?${params}`);
    return res?.data || [];
  };

  const handleFetchSelected = async (id) => {
    const res = await apiCall(`${API_BASE_URL}/customers/${id}`);
    return res?.data;
  };

  return (
    <SearchableSelect
      selectedItemId={selectedCustomerId}
      onSelectItem={onSelectCustomer}
      onSearch={handleSearch}
      onFetchSelected={handleFetchSelected}
      getItemLabel={(c) => `${c.first_name} ${c.last_name}`}
      renderItem={(c) => (
        <>
          <div style={{ fontWeight: 500 }}>{c.first_name} {c.last_name}</div>
          <small style={{ color: '#6c757d' }}>
            {c.phone_number && `\u{1F4DE} ${c.phone_number}`}
            {c.email && (
              <>
                {' \u2022 '}
                <img src={mailIcon} alt="" style={{ width: 12, height: 12, marginLeft: 2, marginRight: 2, verticalAlign: 'middle', display: 'inline-block' }} />
                {c.email}
              </>
            )}
            {` \u2022 ID: ${c.id}`}
          </small>
        </>
      )}
      placeholder="Search by name, phone, email, or ID..."
      label="Customer"
      required={required}
    />
  );
}

export default SearchableCustomerSelect;
